module.exports = __webpack_public_path__ + "img/rspca-sa.e3e42c5.png";